// removed by extract-text-webpack-plugin
module.exports = {"modal":"app-pages-Reports-Shift-ShiftDetail-ShiftDetailModal-__ShiftDetailModal___3Ac3C","dialog":"app-pages-Reports-Shift-ShiftDetail-ShiftDetailModal-__ShiftDetailModal___3v-qG","modal-body":"app-pages-Reports-Shift-ShiftDetail-ShiftDetailModal-__ShiftDetailModal___ggTZq"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Reports/Shift/ShiftDetail/ShiftDetailModal/ShiftDetailModal.css
// module id = 2496
// module chunks = 0